import React, {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import wmsSLAService
from "../../services/wmsSLAService";

export default function SLAPolicyListPage() {

  const navigate = useNavigate();

  const [loading, setLoading] =
    useState(false);

  const [rows, setRows] =
    useState([]);

  const [pagination, setPagination] =
    useState({});

  const [summary, setSummary] =
    useState({

      totalPolicies: 0,
      activePolicies: 0,
      totalRules: 0,
      escalationEnabled: 0,
    });

  const [filters, setFilters] =
    useState({

      q: "",
      work_item_type: "",
      calendar_id: "",

      page: 1,
      per_page: 20,
    });

  useEffect(() => {

    loadData();

  }, [filters.page]);

  async function loadData() {

    try {

      setLoading(true);

      const result =
        await wmsSLAService.listSLAPolicies(
          filters
        );

      const items =
        result.items || [];

      setRows(items);

      setPagination(
        result.pagination || {}
      );

      setSummary({

        totalPolicies:
          items.length,

        activePolicies:
          items.filter(
            x => x.is_active
          ).length,

        totalRules:
          items.reduce(
            (a, b) =>
              a +
              (
                b.rule_count || 0
              ),
            0
          ),

        escalationEnabled:
          items.reduce(
            (a, b) =>
              a +
              (
                b.auto_escalation_rule_count || 0
              ),
            0
          ),
      });

    } catch (err) {

      alert(
        err?.response?.data?.message
        ||
        "Failed to load SLA policies"
      );

    } finally {

      setLoading(false);
    }
  }

  async function handleDelete(
    row
  ) {

    const ok =
      window.confirm(
        `Delete SLA Policy ${row.sla_policy_name}?`
      );

    if (!ok) return;

    try {

      await wmsSLAService.deleteSLAPolicy(
        row.id
      );

      loadData();

    } catch (err) {

      alert(
        err?.response?.data?.message
        ||
        "Delete failed"
      );
    }
  }

  function applyFilters() {

    setFilters(prev => ({
      ...prev,
      page: 1,
    }));

    loadData();
  }

  function clearFilters() {

    setFilters({

      q: "",
      work_item_type: "",
      calendar_id: "",

      page: 1,
      per_page: 20,
    });

    loadData();
  }

  return (

    <div className="container-fluid">

      {/* ===================================================== */}
      {/* HEADER */}
      {/* ===================================================== */}

      <div
        className="card border-0 mb-3"
        style={{
          background:
            "linear-gradient(90deg,#0d6efd,#4f8cff)",
          color: "#fff",
        }}
      >

        <div className="card-body d-flex justify-content-between align-items-center">

          <div>

            <h3 className="mb-1">
              SLA Management
            </h3>

            <div>
              Configure SLA Policies and Rules
            </div>

          </div>

          <button
            className="btn btn-light"
            onClick={() =>
              navigate(
                "/wms/sla-policies/create"
              )
            }
          >
            + Create SLA
          </button>

        </div>

      </div>

      {/* ===================================================== */}
      {/* KPI CARDS */}
      {/* ===================================================== */}

      <div className="row">
      <div className="col-md-3">

        <div
            className="card shadow-sm"
            style={{
            borderTop:
                "3px solid #0d6efd",
            borderRadius: "10px",
            }}
        >

            <div className="card-body">

            <div className="d-flex justify-content-between">

                <div>

                <small
                    className="text-muted"
                >
                    Total Policies
                </small>

                <h2 className="mt-2 mb-0">
                    {
                    summary.totalPolicies
                    }
                </h2>

                </div>

                <div
                style={{
                    fontSize: "28px",
                }}
                >
                📋
                </div>

            </div>

            </div>

        </div>

        </div>      
        
        <div className="col-md-3">

        <div
            className="card shadow-sm"
            style={{
            borderTop: "3px solid #28a745",
            borderRadius: "10px",
            }}
        >

            <div className="card-body">

            <div className="d-flex justify-content-between">

                <div>

                <small className="text-muted">
                    Active Policies
                </small>

                <h2 className="mt-2 mb-0">
                    {summary.activePolicies}
                </h2>

                </div>

                <div style={{ fontSize: "28px" }}>
                ✅
                </div>

            </div>

            </div>

        </div>

        </div>
        
        <div className="col-md-3">

        <div
            className="card shadow-sm"
            style={{
            borderTop: "3px solid #fd7e14",
            borderRadius: "10px",
            }}
        >

            <div className="card-body">

            <div className="d-flex justify-content-between">

                <div>

                <small className="text-muted">
                    Total Rules
                </small>

                <h2 className="mt-2 mb-0">
                    {summary.totalRules}
                </h2>

                </div>

                <div style={{ fontSize: "28px" }}>
                ⏱️
                </div>

            </div>

            </div>

        </div>

        </div>        
      
      <div className="col-md-3">

        <div
            className="card shadow-sm"
            style={{
            borderTop: "3px solid #dc3545",
            borderRadius: "10px",
            }}
        >

            <div className="card-body">

            <div className="d-flex justify-content-between">

                <div>

                <small className="text-muted">
                    Auto Escalation
                </small>

                <h2 className="mt-2 mb-0">
                    {summary.escalationEnabled}
                </h2>

                </div>

                <div style={{ fontSize: "28px" }}>
                ⚠️
                </div>

            </div>

            </div>

        </div>

        </div>      



      </div>

      {/* ===================================================== */}
      {/* FILTERS */}
      {/* ===================================================== */}

      <div
        className="card shadow-sm mb-3"
        style={{
            borderRadius: "10px"
        }}
        >

        <div className="card-header">

          <strong>
            Search & Filters
          </strong>

        </div>

        <div className="card-body">

          <div className="row">

            <div className="col-md-4">

              <label>
                Search
              </label>

              <input
                className="form-control"
                placeholder="Code / Name"
                value={filters.q}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    q: e.target.value,
                  })
                }
              />

            </div>

            <div className="col-md-3">

              <label>
                Work Item Type
              </label>

              <select
                className="form-control"
                value={
                  filters.work_item_type
                }
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    work_item_type:
                      e.target.value,
                  })
                }
              >
                <option value="">
                  All
                </option>
              </select>

            </div>

            <div className="col-md-3">

              <label>
                Calendar
              </label>

              <select
                className="form-control"
                value={
                  filters.calendar_id
                }
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    calendar_id:
                      e.target.value,
                  })
                }
              >
                <option value="">
                  All
                </option>
              </select>

            </div>

          </div>

          <div className="mt-3 text-end">

            <button
              className="btn btn-light me-2"
              onClick={clearFilters}
            >
              Clear
            </button>

            <button
              className="btn btn-primary"
              onClick={applyFilters}
            >
              Apply Filters
            </button>

          </div>

        </div>

      </div>

      {/* ===================================================== */}
      {/* GRID */}
      {/* ===================================================== */}

      <div className="card">

        <div className="card-body p-0">

          <table
            className="table table-hover table-bordered mb-0"
          >

            <thead>

              <tr>

                <th>Code</th>

                <th>Name</th>

                <th>Work Type</th>

                <th>Calendar</th>

                <th>Shift</th>

                <th>Rules</th>

                <th>Status</th>

                <th width="180">
                  Actions
                </th>

              </tr>

            </thead>

            <tbody>

              {loading && (

                <tr>

                  <td
                    colSpan="8"
                    className="text-center"
                  >
                    Loading...
                  </td>

                </tr>
              )}

              {!loading &&
                rows.length === 0 && (

                <tr>

                  <td
                    colSpan="8"
                    className="text-center"
                  >
                    No Records Found
                  </td>

                </tr>
              )}

              {!loading &&
                rows.map((row) => (

                <tr key={row.id}>

                  <td>
                    {row.sla_policy_code}
                  </td>

                  <td>
                    {row.sla_policy_name}
                  </td>

                  <td>
                    {row.applicable_work_item_type}
                  </td>

                  <td>
                    {row.calendar_name}
                  </td>

                  <td>
                    {row.shift_name}
                  </td>

                  <td>
                    {row.rule_count || 0}
                  </td>

                  <td>

                    <span
                      className={
                        row.is_active
                          ? "badge bg-success"
                          : "badge bg-danger"
                      }
                    >
                      {row.is_active
                        ? "Active"
                        : "Inactive"}
                    </span>

                  </td>

                  <td>

                    <button
                      className="btn btn-sm btn-warning me-1"
                      onClick={() =>
                        navigate(
                          `/wms/sla-policies/${row.id}/edit`
                        )
                      }
                    >
                      Edit
                    </button>

                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() =>
                        handleDelete(row)
                      }
                    >
                      Delete
                    </button>

                  </td>

                </tr>
              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}